import Form from 'components/Form';
import { IPatientInfo } from 'apis/admin/type';

import RowContainer from '../components/RowContainer';
import RowContent from '../components/RowContent';

interface Props {
  disabled?: boolean;
  nurseName: string;
  patientInfo: IPatientInfo;
}

const SimulPatientInfo = (props: Props) => {
  const {
    patientInfo: {
      patient_id,
      patient_virtual_id,
      name,
      age,
      gender,
      ward,
      room,
      admin_hod,
      admin_pod,
      department,
      disease_main,
      main_doctor,
    },
  } = props;

  const infos = [
    { title: '환자명', value: name },
    { title: '환자등록번호', value: patient_virtual_id || patient_id },
    { title: '나이', value: age },
    { title: '성별', value: gender },
    { title: '병동', value: ward },
    { title: '병실', value: room },
    { title: '진료과', value: department },
    { title: '진단명', value: disease_main.disease_kor },
  ];

  return (
    <RowContainer xs={12}>
      {infos.map(({ title, value }) =>
        title === '성별' ? (
          <RowContent title={title} titleRatio={1} childrenRatio={2}>
            <Form.MuiRadioGroup
              i18nKey="GENDER"
              values={[1, 2, 3]}
              compact
              value={Number(value)}
              defaultValue={Number(value)}
            />
          </RowContent>
        ) : (
          <RowContent title={title} titleRatio={1} childrenRatio={2}>
            <Form.MuiTextField
              value={value}
              InputProps={{ readOnly: true }}
              onPaste={e => e.preventDefault()}
              onKeyDown={e => {
                if ((e.ctrlKey || e.metaKey) && e.key === 'v') {
                  e.preventDefault();
                }
              }}
              onContextMenu={e => e.preventDefault()}
            />
          </RowContent>
        )
      )}
    </RowContainer>
  );
};

export default SimulPatientInfo;
